import { render, staticRenderFns } from "./SectionFootBanner.vue?vue&type=template&id=2d076cdc&scoped=true"
var script = {}
import style0 from "./SectionFootBanner.vue?vue&type=style&index=0&id=2d076cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d076cdc",
  null
  
)

export default component.exports